import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {
  Store, keys, set, get, del,
} from 'idb-keyval';
import api from '@/api';
import * as ReturnTo from '@/store/modules/returnTo';
import * as SiteAssessment from '@/store/modules/siteAssessment';
import * as SiteVisit from '@/store/modules/siteVisit';
import * as User from '@/store/modules/user';
import * as SiteTaxlots from '@/store/modules/siteTaxlots';
import * as ManagementPlan from '@/store/modules/managementPlan';
import * as Project from '@/store/modules/project';
import * as Membership from '@/store/modules/membership';
import * as WorkorderBill from '@/store/modules/workorderBill';
import * as Contact from '@/store/modules/contact';
import * as Organization from '@/store/modules/organization';
import * as Opportunity from '@/store/modules/opportunity';
import * as Workorder from '@/store/modules/workorder';
import * as Pricelist from '@/store/modules/pricelist';
import * as MathHelper from '@/store/modules/mathHelper';
import * as TargetObjectiveGoal from '@/store/modules/targetObjectiveGoal';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mySites: [],
    currentSite: null,
    config: {},
    configLoaded: false,
    version: null,
    showSidePanel: false,
  },
  getters: {
    isCurrentSiteDownloaded: (state) => {
      if (!state.currentSite) {
        return false;
      }
      return state.mySites.findIndex((site) => site.Id === state.currentSite.Id) >= 0;
    },
    getVersion: (state) => state.version,
  },
  mutations: {
    setCurrentSite(state, site) {
      state.currentSite = site;
    },
    setShowSidePanel(state, visibility) {
      state.showSidePanel = visibility;
    },
    addToMySites(state, site) {
      state.mySites.push(site);
    },
    clearMySites(state) {
      state.mySites = [];
    },
    removeFromMySites(state, site) {
      state.mySites = state.mySites.filter((s) => s.Id !== site.Id);
    },
    setConfiguration(state, config) {
      state.config = config;
    },
    setConfigLoaded(state) {
      state.configLoaded = true;
    },
    setVersion(state, version) {
      state.version = version;
    },
  },
  actions: {
    async fetchSiteAsync({ commit }, siteId) {
      const customStore = new Store('AcornDB', 'sites');
      if (!navigator.onLine) {
        // If the user is offline,
        // return the item from the custom store (which might not exist)
        /* eslint-disable-next-line */
        await get(siteId, customStore).then((site) => {
          return commit('setCurrentSite', site);
        });
      } else {
        // If the user is online,
        // return the item from the system-of-record
        // update the item in the custom store if it exists
        await api.get(`/site/${siteId}`).then(async (response) => {
          // Check and see if the site exists in the custom store
          await get(siteId, customStore).then((dbSite) => {
            if (dbSite && dbSite !== null && dbSite.Id && dbSite.Id === siteId) {
              set(siteId, response.data, customStore);
            }
          });
          return commit('setCurrentSite', response.data);
        });
      }
    },
    async getCurrentSite(context, siteId) {
      const customStore = new Store('AcornDB', 'sites');
      await get(siteId, customStore).then((val) => {
        context.commit('setCurrentSite', val);
      });
    },
    setCurrentSite(context, siteId) {
      context.commit('setCurrentSite', siteId);
    },
    setShowSidePanel(context, visibility) {
      context.commit('setShowSidePanel', visibility);
    },
    removeFromMySites(context, site) {
      const customStore = new Store('AcornDB', 'sites');
      del(site.Id, customStore);
      context.commit('removeFromMySites', site);
    },
    fetchMySites(context) {
      const customStore = new Store('AcornDB', 'sites');
      context.commit('clearMySites');
      keys(customStore).then((ids) => {
        console.log(ids);
        ids.forEach((key) => {
          get(key, customStore).then((val) => {
            context.commit('addToMySites', val);
          });
        });
      });
    },
    async fetchConfiguration({ commit, state }) {
      if (!state.configLoaded) {
        await axios.get('/config.json')
          .then((response) => {
            commit('setConfiguration', response.data);
            commit('setConfigLoaded');
          });
      }
    },
    async fetchVersion({ commit }) {
      await axios.get('/api/version').then((response) => {
        commit('setVersion', response.data);
      });
    },
  },
  modules: {
    ReturnTo,
    SiteAssessment,
    SiteVisit,
    User,
    SiteTaxlots,
    ManagementPlan,
    Project,
    Membership,
    WorkorderBill,
    Contact,
    Organization,
    Opportunity,
    Workorder,
    Pricelist,
    MathHelper,
    TargetObjectiveGoal,
  },
});
